export const LanguageType = {
  Arabic: 1,
  English: 2,
  BiLingual: 3,
};
